import { styled } from 'styled-components';

import { Row } from '~/components/Row';

export const Column = styled(Row)`
  flex-direction: column;
`;
